import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { AdminNav } from './AdminNav';

export function AdminLayout({
  children,
  activeSection,
  onSectionChange,
  isAdmin,
  isReferrer,
  username,
  onSignOut
}) {
  const getInitials = (email) => {
    if (!email) return 'U';
    return email.charAt(0).toUpperCase();
  };


  return (
    <div className="admin-wrapper">
      {/* Header */}
      <header className="admin-header">
        <div className="admin-header-content">
          <a href="/">
            <img src="./qmi.png" alt="QMI" className="admin-logo" />
          </a>

          <div className="admin-header-right">
            <div className="admin-user-info">
              {isAdmin && <span className="admin-role-badge">Admin</span>}
              <div className="admin-user-avatar">
                {getInitials(username)}
              </div>
              <span className="admin-user-name">{username}</span>
            </div>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={onSignOut}
            >
              Sign Out
            </Button>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <AdminNav
        activeSection={activeSection}
        onSectionChange={onSectionChange}
        isAdmin={isAdmin}
        isReferrer={isReferrer}
      />

      {/* Content */}
      <main className="admin-content">
        {children}
      </main>
    </div>
  );
}
